
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

window.gsap = gsap
window.ScrollTrigger = ScrollTrigger

gtag('event', 'view_landing_homepage');

window.addEventListener('load', () => {
    document.querySelectorAll('.rd-trigger-ga').forEach(function (item) {
        item.addEventListener('click', function () {
            gtag('event', item.getAttribute('data-ga'));
        })
    })
})

ScrollTrigger.create({
    trigger: "#story",
    start: "top top+=70%",
    markers:false,
    onEnter: function () {

        gtag('event', 'view_landing_homepage_story');
    }
});
ScrollTrigger.create({
    trigger: "#timetable",
    start: "top top+=70%",
    markers:false,
    onEnter: function () {

        gtag('event', 'view_landing_homepage_mrt_timetable');
    }
});
ScrollTrigger.create({
    trigger: "#station",
    start: "top top+=70%",
    markers:false,
    onEnter: function () {

        gtag('event', 'view_landing_homepage_mrt');
        gtag('event', 'view_landing_homepage_mrt_station');
    }
});
